export const NOTIFICACAO_PUSH_LOAD_CLIENTS = "NOTIFICACAO_PUSH_LOAD_CLIENTS";
export const NOTIFICACAO_PUSH_SEND = "NOTIFICACAO_PUSH_SEND";
export const NOTIFICACAO_PUSH_GET_ENVIO = "NOTIFICACAO_PUSH_GET_ENVIO";
export const NOTIFICACAO_PUSH_AGENDAR = "NOTIFICACAO_PUSH_AGENDAR";
export const NOTIFICACAO_PUSH_GET_AGENDAMENTO = "NOTIFICACAO_PUSH_GET_AGENDAMENTO";
export const NOTIFICACAO_PUSH_ATUALIZAR_AGENDAMENTO =
  "NOTIFICACAO_PUSH_ATUALIZAR_AGENDAMENTO";
export const NOTIFICACAO_PUSH_CANCELAR_AGENDAMENTO =
  "NOTIFICACAO_PUSH_CANCELAR_AGENDAMENTO";
